var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4842 6.15085C13.1267 5.79335 12.5492 5.79335 12.1917 6.15085L7.98419 10.3583C7.62669 10.7158 7.62669 11.2933 7.98419 11.6508L12.1917 15.8583C12.5492 16.2158 13.1267 16.2158 13.4842 15.8583C13.8417 15.5008 13.8417 14.9233 13.4842 14.5658L9.92752 11L13.4842 7.44335C13.8417 7.08585 13.8325 6.49918 13.4842 6.15085Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftIcon);
export default __webpack_public_path__ + "static/media/ChevronLeftIcon.44032ad8cebfb0d512fdfcca57906c62.svg";
export { ForwardRef as ReactComponent };